import apiHandler from "../core/apiHandler";

// 📌 Crea un handler base para los endpoints de categorías de módulos
const moduleCategoryApi = apiHandler("module-categories");

export default moduleCategoryApi;
